module.exports = __webpack_public_path__ + "static/media/5008.b3ca765a.png";